export const USER_ID_PARAM_NAME = 'c';
export const SIGNATURE_PARAM_NAME = 'sg';
